// extracted by mini-css-extract-plugin
module.exports = {"auditMonthHeading":"auditMonthStickyHeader_auditMonthHeading__32VEu","text":"auditMonthStickyHeader_text__1GVVo","hr":"auditMonthStickyHeader_hr__2ypKC"};